import { GET_FIREBASE_UID, GET_USER_SUCCESS } from "./actionType";

export const handleGetUserSuccess = (payload) => {
  return {
    type: GET_USER_SUCCESS,
    payload,
  };
};

export const handleGetFirebaseUid = (payload) => {
  return {
    type: GET_FIREBASE_UID,
    payload,
  };
};
